const createMarkupFAQ = (pageFAQ) => {
  const markup = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity:
      pageFAQ &&
      pageFAQ.map((faq) => {
        return {
          '@type': 'Question',
          name: faq.title,
          acceptedAnswer: {
            '@type': 'Answer',
            text: faq.content,
          },
        };
      }),
  };
  return JSON.stringify(markup);
};

export default createMarkupFAQ;
